import { useEffect, useRef } from "react";
import { CheckMarkIcon, MinusIcon } from "../../assets/icons";
import classNames from "classnames";

import styles from "./checkbox.module.css"

export const Checkbox = ({
    checked,
    onChange,
    className,
    error,
    disabled = false,
    indeterminate = false,
    children,
}) => {
    const inputRef = useRef(null);

    useEffect(() => {
        if (inputRef.current) inputRef.current.indeterminate = indeterminate && !checked;
    }, [indeterminate, checked]);

    return (
        <label
            className={classNames(
                styles.checkbox_container,
                className,
                {
                    [styles.error]: error,
                    [styles.disabled]: disabled,
                    [styles.with_label]: !!children,
                },
            )}
        >
            <input
                ref={inputRef}
                type="checkbox"
                checked={checked}
                disabled={disabled}
                onChange={(event) => {
                    if (!disabled) onChange?.(event.target.checked);
                }}
            />
            <span className={styles.control}>
                <CheckMarkIcon className={styles.checkmark} />
                <MinusIcon className={styles.dash} />
            </span>
            {!!children && <span className={styles.label}>{children}</span>}
        </label>
    );
};
